import {ReplaySubject} from 'rxjs';
import type {ContractPair} from '@/types';

export const contract$ = new ReplaySubject<ContractPair>(1);
